.surface {
  min-width: 0;
  border-radius: var(--radius-lg);
}

.plain {
  background: transparent;
}

.raised,
.interactive {
  background: var(--surface-raised);
  border: 1px solid var(--line-subtle);
}

.interactive {
  transition:
    background var(--duration-fast) var(--ease),
    border-color var(--duration-fast) var(--ease);
}

.interactive:hover {
  background: var(--surface-inset);
  border-color: var(--line-strong);
}

.interactive:focus-within {
  border-color: var(--accent-dim);
}

.inset {
  background: var(--surface-inset);
  border: 1px solid var(--line-subtle);
}

.paddingNone {
  padding: 0;
}

.paddingCompact {
  padding: var(--space-3);
}

.paddingNormal {
  padding: var(--space-5);
}

@media (prefers-reduced-motion: reduce) {
  .interactive {
    transition: none;
  }
}
